import config from "../config";

export const appName = "webApp";

export function getApiKeyHeader() {
  if (config.useNewApiGateway) {
    return { "x-api-key": `${process.env.CLIENT}-tenant-identifier` };
  } else {
    return {};
  }
}

export function fetchWithHeaders(url) {
  return fetch(url, {
    headers: {
      ...getApiKeyHeader(),
    },
  });
}

export function getRequest(url) {
  return fetchWithHeaders(url).then((resp) => resp.json());
}

export function postRequest(url, params) {
  return fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...getApiKeyHeader(),
    },
    method: "POST",
    body: JSON.stringify(params),
  }).then((resp) => resp.json());
}



// WEBPACK FOOTER //
// ./src/common/utilities/apimanager.helper.js